import Vue from 'vue';
import Router from 'vue-router';
import routes from '@/router/paths';
import store from '@/store';

Vue.use(Router);

function routing(path, page, name, title, authRequired) {
  return {
    name: page || name,
    path,
    component: async () => import('@/views/' + page + '.vue'),
    meta: {
      title: title || name,
      authRequired: authRequired || false
    }
  };
}

const verifyIfUserIsAuthenticated = async (to, from, next) => {
  await store.dispatch('login/initApp');

  if (store.state.login.isAuthenticated) {
    next();
  }
  next();
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes.map(r => {
    const route = routing(
      r.path,
      r.page,
      r.name,
      r.title,
      r.authRequired
    );
    if (r.authRequired) {
      route.beforeEnter = verifyIfUserIsAuthenticated;
    }

    return route;
  })
});

router.beforeEach(async (to, from, next) => {
  let objJson = null;
  await store.dispatch('login/initApp');
  if (to.path === '/passwordReset') {
    if (to.query) {
      if (to.query.value) {
        // store.state.passwordResetKey = to.query.value;
        // const passwordResetKey = to.query.value;
        // objJson = {
        //   name: 'PasswordResetExecution',
        //   params: {
        //     passwordResetKey: passwordResetKey
        //   }
        // };
      }
    }
  } else if (store.state.election.dateElectionOk && store.state.election.stateElectionOk) {
    // if (to.path != '/passwordReset') {
    //   if (!store.state.login.isAuthenticated && to.path === '/urna') {
    //     objJson = { name: 'Login' };
    //   }
    //   if (!store.state.login.isAuthenticated && to.path === '/Mosaico') {
    //     objJson = { name: 'Login' };
    //   }
    // }
    const objPath = { URN: '/urna', MOSAIC: '/Mosaico' };
    switch (to.path) {
      case objPath.URN:
      case objPath.MOSAIC:
        if (!store.state.login.isAuthenticated) {
          objJson = { name: 'Login' };
        }
        break;
      default:
        break;
    }
  } else {
    if (to.name !== 'Election') {
      if (to.query) {
        if (to.query.identifier && to.query.key) {
          store.state.idElection = to.query.identifier;
          store.state.accessKey = to.query.key;
        }
      }
      objJson = { name: 'Election' };
    }
  }
  // if ((!store.state.election.dateElectionOk || !store.state.election.stateElectionOk) && to.name !== 'Election') {
  //   /*
  //     if (to.path !== '/Election') {
  //       store.state.pathElection = to.path;
  //     }
  //   */
  //   if (to.query) {
  //     if (to.query.identifier && to.query.key) {
  //       store.state.idElection = to.query.identifier;
  //       store.state.accessKey = to.query.key;
  //     }
  //   }
  //   objJson = { name: 'Election' };
  // }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (objJson) {
    next(objJson);
  } else {
    next();
  }
});

export default router;
